import useAuthenticatedQuery from "./useAuthenticatedQuery";

const useGetActiveCheckoutSession = (enabled = false) => {
  const {
    data: checkoutSession,
    isLoading: checkoutSessionLoading,
    error: checkoutSessionError,
    refetch: refetchCheckoutSession,
  } = useAuthenticatedQuery(
    ["activeCheckoutSession"],
    "/api/v1/subscriptions/checkout-session/active",
    {
      enabled,
      // Don't show error toast for 404 (no active session)
      useErrorBoundary: false,
      // Don't retry on 404 or NOT_FOUND error
      retry: (failureCount, error) => {
        const isNotFound =
          error.response?.status === 404 ||
          error.response?.data?.error_code === "NOT_FOUND";
        return !isNotFound && failureCount < 2;
      },
      // Log errors for debugging
      onError: (error) => {
        console.log("Checkout session check error:", {
          status: error.response?.status,
          data: error.response?.data,
          error_code: error.response?.data?.error_code,
        });
      },
    }
  );

  return {
    checkoutSession,
    checkoutSessionLoading,
    checkoutSessionError,
    refetchCheckoutSession,
  };
};

export default useGetActiveCheckoutSession;
